(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.install(root);
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  var separator = 'jLj';
  var destinations = new Set(['0q8jpp-6g.myshopify.com', '2znixs-yy.myshopify.com', '7ge53q-0b.myshopify.com', 'edelcars.shop', 'edelwagen.shop', 'edelmotion.store']);
  var pixelScript = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
  var googlePixelScript = 'https://cdn.utmify.com.br/scripts/pixel/pixel-google.js';
  var utmsScript = 'https://cdn.utmify.com.br/scripts/utms/latest.js';

  function safeOpaque(value) {
    return typeof value === 'string' && value.length > 0 && value.length <= 512 && !/[\u0000-\u0020\u007f-\u009f]/.test(value) && value.indexOf(separator) < 0;
  }
  function readPixelLead(win, key, pixelId) {
    try {
      var lead = JSON.parse(win.localStorage.getItem(key) || 'null');
      return pixelId && lead && lead.pixelId === pixelId && safeOpaque(lead._id) ? lead : null;
    } catch (_) { return null; }
  }
  function readLead(win, config) { return readPixelLead(win, 'lead', config.utmifyPixelId); }
  function googleConfigured(config) { return /^[a-f0-9]{24}$/.test(config.googleUtmifyPixelId || ''); }
  function safeClickId(value) {
    return typeof value === 'string' && value.length > 0 && value.length <= 1024 && !/[\u0000-\u0020\u007f-\u009f]/.test(value);
  }
  function appendGoogleClickIds(win, config, url) {
    if (!googleConfigured(config)) return;
    var current;
    try { current = new URLSearchParams(win.location.search || ''); } catch (_) { current = new URLSearchParams(); }
    var lead = readPixelLead(win, 'lead-google', config.googleUtmifyPixelId);
    ['gclid', 'gbraid', 'wbraid'].forEach(function (key) {
      // New incoming identifiers win; an older SDK lead must not replace this click.
      var value = current.has(key) ? current.get(key) : url.searchParams.has(key) ? url.searchParams.get(key) : lead && lead[key];
      if (value == null && !current.has(key) && !url.searchParams.has(key)) return;
      if (!safeClickId(value)) {
        url.searchParams.delete(key);
        url.searchParams.delete('attributes[' + key + ']');
        return;
      }
      url.searchParams.set(key, value);
      url.searchParams.set('attributes[' + key + ']', value);
    });
  }
  function appendAttribution(win, config, permitted, input) {
    var original = String(input);
    if (!permitted || config.role !== 'source') return original;
    var url;
    try { url = new URL(original); } catch (_) { return original; }
    if (url.protocol !== 'https:' || !destinations.has(url.hostname) || !/^\/(?:pt(?:-[a-z0-9]{2,8})*\/)?cart\//.test(url.pathname)) return original;
    var lead = readLead(win, config);
    if (lead) {
      var base = url.searchParams.get('utm_source');
      if (!base) {
        try { base = new URLSearchParams(win.location.search || '').get('utm_source'); } catch (_) {}
      }
      // The original UTM remains the prefix; an existing vendor lead suffix is replaced.
      base = String(base || 'organic').split(separator)[0];
      var value = base + separator + lead._id;
      url.searchParams.set('utm_source', value);
      url.searchParams.set('attributes[utm_source]', value);
    }
    appendGoogleClickIds(win, config, url);
    if (!lead && !googleConfigured(config)) return original;
    return url.toString();
  }
  function validAddToCart(data, eventId) {
    if (!safeOpaque(eventId) || !data || data.currency !== 'EUR' || !Number.isFinite(data.value) || data.value < 0 || !Number.isSafeInteger(data.num_items) || data.num_items < 1) return false;
    if (!Array.isArray(data.content_ids) || data.content_ids.length !== 1 || !/^MS-(AUTO|PICKUP)-(OHNE|MIT)-(SCHWARZ|GRAU|BEIGE)$/.test(String(data.content_ids[0]))) return false;
    if (!Array.isArray(data.contents) || data.contents.length !== 1 || data.contents[0].id !== data.content_ids[0] || data.contents[0].quantity !== data.num_items) return false;
    var unitPrice = data.contents[0].item_price;
    if (!Number.isFinite(unitPrice) || unitPrice < 0) return false;
    var unitCents = Math.round(unitPrice * 100), valueCents = Math.round(data.value * 100);
    return Number.isSafeInteger(unitCents) && Number.isSafeInteger(valueCents) && Math.abs(unitPrice * 100 - unitCents) < 0.000001 && Math.abs(data.value * 100 - valueCents) < 0.000001 && unitCents * data.num_items === valueCents;
  }
  function install(win) {
    if (win.EdelCarTracking) return win.EdelCarTracking;
    var config = win.EDELCAR_TRACKING_CONFIG || {};
    var baseEnabled = config.enabled === true && /^(source|white)$/.test(config.role);
    var metaEnabled = baseEnabled && /^[a-f0-9]{24}$/.test(config.utmifyPixelId || '') && /^\d{8,20}$/.test(config.metaPixelId || '');
    var googleEnabled = baseEnabled && googleConfigured(config);
    var enabled = metaEnabled || googleEnabled;
    var allowed = false, metaStarted = false, googleStarted = false, loading = false, reloading = false, privacyReady = false;
    var queue = [], seen = new Set(), flushTimer = null, featureAttempts = 0;
    var api = {
      appendAttributionToCartUrl: function (url) { return appendAttribution(win, config, enabled && allowed, url); },
      consentAllowed: function () { return enabled && allowed; },
      trackAddToCart: function (data, id) {
        if (!metaEnabled || !metaStarted || !allowed || config.role !== 'source' || !validAddToCart(data, id) || seen.has(id)) return false;
        seen.add(id);
        if (queue.length >= 20) queue.shift();
        queue.push({data: data, id: id});
        flush();
        return true;
      }
    };
    win.EdelCarTracking = api;
    if (!enabled) return api;

    function permitted() {
      var privacy = win.Shopify && win.Shopify.customerPrivacy;
      try {
        return privacyReady && privacy && typeof privacy.marketingAllowed === 'function' && typeof privacy.analyticsProcessingAllowed === 'function' && typeof privacy.saleOfDataAllowed === 'function' && privacy.marketingAllowed() === true && privacy.analyticsProcessingAllowed() === true && privacy.saleOfDataAllowed() === true;
      } catch (_) { return false; }
    }
    function flush() {
      if (!allowed || !metaStarted) { queue = []; return; }
      var lead = readLead(win, config);
      // The vendor initialises Meta before saving its PageView response into lead.
      if (!lead || !Array.isArray(lead.metaPixelIds) || lead.metaPixelIds.indexOf(config.metaPixelId) < 0 || typeof win.fbq !== 'function') return;
      while (queue.length && permitted()) {
        var event = queue.shift();
        win.fbq('trackSingle', config.metaPixelId, 'AddToCart', event.data, {eventID: event.id});
      }
      if (!permitted()) queue = [];
    }
    function loadScript(source, id, attributes) {
      if (win.document.getElementById(id)) return;
      var script = win.document.createElement('script');
      script.id = id;
      script.src = source;
      script.async = true;
      Object.keys(attributes || {}).forEach(function (name) { script.setAttribute(name, attributes[name]); });
      win.document.head.appendChild(script);
    }
    function cleanForeignLead(key, pixelId) {
      try {
        var oldLead = JSON.parse(win.localStorage.getItem(key) || 'null');
        if (oldLead && oldLead.pixelId !== pixelId) win.localStorage.removeItem(key);
      } catch (_) {}
    }
    function refreshGoogleClick() {
      try {
        var lead = JSON.parse(win.localStorage.getItem('lead-google') || 'null');
        if (!lead || lead.pixelId !== config.googleUtmifyPixelId) return;
        var current = new URLSearchParams(win.location.search || '');
        if (['gclid', 'gbraid', 'wbraid'].some(function (key) {
          var value = current.get(key);
          return current.has(key) && safeClickId(value) && value !== lead[key];
        })) win.localStorage.removeItem('lead-google');
      } catch (_) {}
    }
    function loadUtms() {
      var attributes = {};
      if (config.role === 'white') {
        attributes['data-utmify-prevent-xcod-sck'] = '';
        attributes['data-utmify-prevent-subids'] = '';
      }
      loadScript(utmsScript, 'edelcar-utmify-utms', attributes);
    }
    function start() {
      if (!permitted()) return;
      // Each bundle has its own global and storage namespace; a collision affects only it.
      if (metaEnabled && !metaStarted && (!win.pixelId || win.pixelId === config.utmifyPixelId)) {
        cleanForeignLead('lead', config.utmifyPixelId);
        metaStarted = true;
        win.pixelId = config.utmifyPixelId;
        loadUtms();
        loadScript(pixelScript, 'edelcar-utmify-pixel');
        if (config.role === 'source') flushTimer = win.setInterval(flush, 250);
      }
      if (googleEnabled && !googleStarted && (!win.googlePixelId || win.googlePixelId === config.googleUtmifyPixelId)) {
        cleanForeignLead('lead-google', config.googleUtmifyPixelId);
        refreshGoogleClick();
        googleStarted = true;
        win.googlePixelId = config.googleUtmifyPixelId;
        loadUtms();
        loadScript(googlePixelScript, 'edelcar-utmify-google-pixel');
      }
    }
    function updateConsent() {
      var previously = allowed;
      allowed = permitted();
      if (!allowed) {
        queue = [];
        if (flushTimer) { win.clearInterval(flushTimer); flushTimer = null; }
        if (typeof win.fbq === 'function') win.fbq('consent', 'revoke');
        // The vendor has no unload API. A fresh page stops its timers and listeners.
        if (previously && (metaStarted || googleStarted) && !reloading) {
          reloading = true;
          win.location.reload();
        }
        return;
      }
      if (typeof win.fbq === 'function') win.fbq('consent', 'grant');
      start();
      flush();
    }
    function loadPrivacy() {
      if (loading || privacyReady || featureAttempts >= 12) return;
      if (!win.Shopify || typeof win.Shopify.loadFeatures !== 'function') {
        featureAttempts++;
        win.setTimeout(loadPrivacy, 250);
        return;
      }
      loading = true;
      win.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
        loading = false;
        if (error) return;
        privacyReady = true;
        updateConsent();
      });
    }
    if (metaEnabled && config.role === 'source' && typeof win.metaTrack !== 'function') {
      win.metaTrack = function (name, data, id) { return name === 'AddToCart' && api.trackAddToCart(data, id); };
    }
    win.document.addEventListener('visitorConsentCollected', updateConsent);
    loadPrivacy();
    return api;
  }
  return {install: install, appendAttribution: appendAttribution, validAddToCart: validAddToCart};
});
